export const sum = ( ...args: number[] ): number => args.reduce(( a, b ) => a + b, 0 );
